<form #userForm="ngForm">
    <div class="container-fluid" *ngIf="companies">
        <h2 class="heading-new-user">{{ 'user.new' | translate }}</h2>
        <div class="error-box">
            <span *ngIf="errorUser" class="error col-12 col-xl-8">
                {{ 'user.error_new_user' | translate }}
            </span>
            <span *ngIf="userExists" class="error col-12 col-xl-8">
                {{ 'errors.error_user_exists' | translate }}
            </span>
        </div>
        <div class="row" *ngIf="!showPersonalDataForm">
            <div class="col-12 col-xl-8 form-container">
                <div class="mb-3">
                    <label for="">{{ 'user.country' | translate }}</label>
                    <ng-select
                        name="country"
                        [items]="countries"
                        [(ngModel)]="country"
                        [clearable]="false"
                        [searchable]="true"
                        bindValue="code"
                        bindLabel="name"
                        [editableSearchTerm]="true"
                        required
                        (change)="filterCities()"
                    >
                    </ng-select>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.city' | translate }}</label>
                    <ng-select
                        name="city"
                        [items]="cities"
                        [(ngModel)]="city"
                        [clearable]="false"
                        [searchable]="true"
                        bindValue="name"
                        bindLabel="name"
                        [editableSearchTerm]="true"
                        required
                        [readonly]="country === null"
                        (change)="filterCompanies()"
                        #cityNgSelectComponent
                    >
                    </ng-select>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.company' | translate }}</label>
                    <ng-select
                        name="companyId"
                        [items]="selectableCompanies"
                        [(ngModel)]="user.companyId"
                        [clearable]="false"
                        [searchable]="true"
                        bindValue="id"
                        bindLabel="name"
                        [editableSearchTerm]="true"
                        required
                        [readonly]="city === null || selectableCompanies.length === 0"
                        #companyNgSelectComponent
                        (change)="setUserRequestForCompanyName($event)"
                    >
                    </ng-select>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="showPersonalDataForm">
            <div class="col-12 col-xl-8 form-container">
                <div class="col-4">
                    <div class="mb-3">
                        <label for="">{{ 'user.position' | translate }}</label>
                        <ng-select
                            name="role"
                            [items]="roles"
                            [clearable]="false"
                            [searchable]="true"
                            [(ngModel)]="user.role"
                            bindValue="code"
                            bindLabel="name"
                            [editableSearchTerm]="true"
                            required
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.name' | translate }}</label>
                    <input
                        name="firstName"
                        type="text"
                        class="form-control"
                        [(ngModel)]="user.firstName"
                        pattern="^([^\$%\^*£=~@\d]+)+$"
                        maxlength="49"
                        required
                        #firstName="ngModel"
                    />
                    <div *ngIf="firstName.errors?.pattern" class="error_input">
                        {{ 'errors.error_name' | translate }}
                    </div>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.lastname' | translate }}</label>
                    <input
                        name="lastname"
                        type="text"
                        class="form-control"
                        [(ngModel)]="user.lastName"
                        pattern="^([^\$%\^*£=~@\d]+)+$"
                        maxlength="49"
                        required
                        #lastName="ngModel"
                    />
                    <div *ngIf="lastName.errors?.pattern" class="error_input">
                        {{ 'errors.error_name' | translate }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="mb-3">
                            <label for="">{{ 'user.email' | translate }}</label>
                            <input
                                name="email"
                                type="email"
                                class="form-control"
                                [(ngModel)]="user.email"
                                pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                required
                                #email="ngModel"
                            />
                            <div *ngIf="email.errors?.pattern" class="error_input">
                                {{ 'errors.error_email' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="mb-3">
                            <label for="">{{ 'user.language' | translate }}</label>
                            <ng-select
                                name="language"
                                [items]="languages"
                                [clearable]="false"
                                [searchable]="true"
                                bindValue="code"
                                bindLabel="name"
                                [(ngModel)]="user['language']"
                                [editableSearchTerm]="true"
                                placeholder="English"
                            >
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.phone' | translate }}</label>
                    <div class="d-flex">
                        <input
                            name="phone-prefix"
                            type="text"
                            class="form-control prefix"
                            min="2"
                            max="6"
                            [(ngModel)]="prefix"
                            [required]="phone != '' "
                            pattern="^([0]{2})([\d]{1,5})"
                            #error="ngModel"
                         />
                        <input
                            name="phone"
                            type="text"
                            class="form-control"
                            [(ngModel)]="phone"
                            [required]="prefix != '' "
                            pattern="(^[\d]{1,})([\d\s-])+$"
                            #error2="ngModel"
                        />
                    </div>
                    <div *ngIf="error.errors?.pattern || (phone != '' && prefix == '' ) " class="error_input">
                        {{ 'errors.error_prefix' | translate }}
                    </div>
                    <div *ngIf="error2.errors?.pattern || (prefix != '' && phone == '' ) " class="error_input">
                        {{ 'errors.error_phone' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3 justify-content-center">
            <div class="col-12 text-center button-container">
                <button (click)="goBack()" class="btn btn-outline-primary ms-0">
                    {{ 'user.btn_back' | translate }}
                </button>
                <button
                    class="btn btn-primary me-2"
                    *ngIf="!showPersonalDataForm"
                    [disabled]="!(user.companyId>0)"
                    (click)="next()"
                >
                    {{ 'user.btn_next' | translate }}
                </button>
                <button
                    class="btn btn-primary me-2"
                    *ngIf="showPersonalDataForm"
                    (click)="checkIfUserExists(user)"
                    [disabled]="!(userForm.valid && user.role && user.email && user.firstName && user.lastName)"
                >
                    {{ 'user.btn_save' | translate }}
                </button>
            </div>
        </div>
    </div>
</form>
<div *ngIf="userSaved" class="modal-container" (click)="closeModal()">
    <div class="modal-content text-center">
        <div class="close-btn">
            <img src="../../../assets/icons/close.png" alt="" />
        </div>
        <h2>{{ modalText | translate }}</h2>
    </div>
</div>
